//by param
export const roomByStages = {
  extract: (room) => room.stageAddressLifeCycle?.id,
};

export const roomBySteps = {
  extract: (room) => room.stepAddressLifeCycle?.id,
};

export const roomByRecordDate = {
  extract: (room) => room.recordInfo?.acceptanceDate,
};

export const roomByTypes = { extract: (room) => room.typeId };

export const roomByAcceptanceStatuses = {
  extract: (room) => room.recordInfo?.acceptanceStatusAddressLifeCycle?.id ?? 0,
};

export const roomByFinishType = {
  extract: (room) => room.addressTypeOfFinish?.id ?? 0,
};

export const roomByAcceptanceDesks = {
  extract: (room) => room.recordInfo?.acceptanceDesk?.id,
};

export const roomByPorch = { extract: (room) => room.porch };

export const roomByNumber = { extract: (room) => room.flat };
export const roomByAddressDdu = { extract: (room) => room.addressDdu };
export const roomByNumberDdu = { extract: (room) => room.numberDdu };

export const houseByRegion = { extract: (house) => house.regionId };

// by search
export const companyBySearch = { extract: (company) => company.name };

export const houseBySearch = {
  extract: extractHouseDataForSearch,
};

export const roomBySearch = {
  extract: (room) => {
    const { typeName, ...other } = room;
    return [extractHouseDataForSearch(other), extractRoomDataForSearch(room)]
      .filter(Boolean)
      .join('');
  },
};

export const selectedHousesBySearch = { extract: (item) => item.name };

// by search tree
export const relatedRoomTreeBySearch = [
  { extract: (item) => item.name, childrenKey: 'rooms' },
  { extract: extractRoomDataForSearch, childrenKey: 'relatedRooms' },
  { extract: extractRoomDataForSearch },
];

function extractHouseDataForSearch(house) {
  const { streetName, building, corpus, typeName } = house;
  return [streetName, building, corpus, typeName].filter(Boolean).join('');
}

function extractRoomDataForSearch(room) {
  const { flat, typeName } = room;
  return [flat, typeName].filter(Boolean).join('');
}
